import { formbricksApi } from "../index";

export const surveyApi = formbricksApi.injectEndpoints({
    endpoints: (build) => ({
        createSurvey: build.mutation({
            query: (body) => ({
                url: "management/surveys",
                body,
                method: "POST",
            }),
            invalidatesTags: () => [{ type: "Surveys" }],
        }),
        getSurveys: build.query({
            query: (params) => {
                const query = new URLSearchParams(params).toString();
                return `management/surveys?${query}`;
            },
            providesTags: () => [{ type: "Surveys" }],
        }),
        getSurveyById: build.query({
            query: (id) => `management/surveys/${id}`,
            providesTags: (result, error, arg) => [{ id: arg, type: "Survey" }],
        }),
        getResponsesBySurveyId: build.query({
            query: (surveyId) =>
                `management/surveys/${surveyId}/response`,
            providesTags: (result, error, arg) => [{ id: arg, type: "Survey" }],
        }),
        updateSurveyById: build.mutation({
            query: ({ id, body }) => ({
                url: `management/surveys/${id}`,
                body,
                method: "PUT",
            }),
            invalidatesTags: (result, error, arg) => [
                { type: "Surveys" },
                { id: arg.id, type: "Survey" },
            ],
        }),
        getEnvironment: build.query({
            query: () => "management/me",
        }),
        deleteSurveyById: build.mutation({
            query: (id) => ({
                url: `management/surveys/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: () => [{ type: "Surveys" }],
        }),
        createResponse: build.mutation({
            query: ({ environmentId, body }) => ({
                url: `client/responses`,
                method: "POST",
                body,
            }),
            invalidatesTags: (result, error, arg) => [
                { id: result.surveyId, type: "Survey" },
            ],
        }),
        createFileInStorage: build.mutation({
            query: (body) => ({
                url: `management/storage`,
                method: "POST",
                body,
            }),
        }),
        createDaylightProjectOnSurvey: build.mutation({
            query: ({ surveyId }) => ({
                url: `management/surveys/${surveyId}/project`,
                method: "POST",
            }),
            invalidatesTags: () => [{ type: "Projects" }],
        }),
        getTasksByProjectId: build.query({
            query: (projectId) => `projects/${projectId}/tasks`,
            providesTags: (result, error, arg) => [{ type: "Tasks", id: arg }],
        }),
    }),
});

export const {
    useCreateSurveyMutation,
    useGetSurveysQuery,
    useGetSurveyByIdQuery,
    useDeleteSurveyByIdMutation,
    useUpdateSurveyByIdMutation,
    useGetResponsesBySurveyIdQuery,
    useCreateResponseMutation,
    useGetEnvironmentQuery,
    useCreateFileInStorageMutation,
    useCreateDaylightProjectOnSurveyMutation,
    useGetTasksByProjectIdQuery,
} = surveyApi;
